module.exports = __webpack_public_path__ + "static/media/todo.dc9b2907.jpg";